import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Spinner, VStack, Text } from '@chakra-ui/react';

const QRRedirect: React.FC = () => {
  const { encodedValue } = useParams<{ encodedValue: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (encodedValue) {
      // Paymentsページに遷移して、encodedValueをstateで渡す
      navigate('/main/payments', {
        replace: true,
        state: { qrEncodedValue: encodedValue },
      });
    } else {
      // エンコード値がない場合はpaymentsページにリダイレクト
      navigate('/main/payments', { replace: true });
    }
  }, [encodedValue, navigate]);

  return (
    <Box w="full" h="100%" display="flex" alignItems="center" justifyContent="center">
      <VStack gap={4}>
        <Spinner size="xl" color="teal.500" />
        <Text fontSize="sm" color="gray.600">
          QRコードを処理しています...
        </Text>
      </VStack>
    </Box>
  );
};

export default QRRedirect;
